import { PropsWithChildren } from "react";

export function CardTitle({ children }: PropsWithChildren) {
  return <h1 className="text-sm font-medium text-text-base-primary">{children}</h1>;
}
